import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Map } from 'immutable';
import VisibilitySensor from 'react-visibility-sensor';
import { FormattedMessage } from 'react-intl';

import { EXISTING_ACCOUNT_LOGIN_IMPRESSION, EXISTING_ACCOUNT_LOGIN_CLICK } from 'lib/analytics/events';
import { routerLocationShape } from 'lib/common/prop-types';
import { buildRedirectURI } from 'lib/common/url-helpers';

import Brand from 'models/brand';

import SignInForm from 'containers/common/sign-in-form';
import BrandName from 'containers/common/brand-name';

import trackEventCreator from 'action-creators/analytics/track-event';
import signIn from 'action-creators/account/sign-in';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  trackEvent: PropTypes.func.isRequired,
  routerLocation: routerLocationShape.isRequired,
  errors: PropTypes.instanceOf(Map).isRequired,
};
// TODO this needs to be refactored, don't like these as state variables
class SignInModal extends Component {
  constructor(props) {
    super(props);

    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.state = {
      show: false,
    };

    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
    this.handleLoginVisibilityChange = this.handleLoginVisibilityChange.bind(this);
  }

  handleModalShow(e) {
    e.preventDefault();

    this.setState({
      show: true,
    });

    this.props.trackEvent(EXISTING_ACCOUNT_LOGIN_CLICK);
  }

  handleModalClose() {
    this.setState({
      show: false,
    });
  }

  handleLoginVisibilityChange(visible) {
    if (visible) {
      this.props.trackEvent(EXISTING_ACCOUNT_LOGIN_IMPRESSION);
    }
  }

  renderErrors() {
    if (this.props.errors.signIn && this.props.errors.signIn.length > 0) {
      return (
        <p className="sign-in-errors">
          {this.props.errors.signIn[0].message}
        </p>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="panel-body">
        <div>
          <VisibilitySensor onChange={this.handleLoginVisibilityChange} partialVisibility>
            <a href="#sign-in-modal" onClick={this.handleModalShow}>
              <FormattedMessage
                id="checkout.have-an-account-sign-in"
                defaultMessage="Have a {brand} account? Sign in"
                values={{
                  brand: <BrandName />,
                }}
              />
            </a>
          </VisibilitySensor>
        </div>

        <Modal className="sign-in-modal checkout-modal" show={this.state.show} onHide={this.handleModalClose}>
          <Modal.Body>
            <div className="sign-in">
              <div className="container-fluid">
                <div className="row display-flex">
                  <div className="sign-in-column margin-top-10 col-gutter-30 col-md-12 col-xs-12 background-white sign-in-form">
                    <SignInForm
                      routerLocation={{ search: buildRedirectURI(this.props.routerLocation) }}
                      brand={this.props.brand}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let {
    location: routerLocation,
  } = state.router;
  if (!routerLocation) {
    ({ routerLocation } = ownProps);
  }

  const {
    errors,
  } = state.account;

  const {
    brand,
  } = state.brand;

  return {
    brand,
    errors,
    routerLocation,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    signIn,
    trackEvent: trackEventCreator,
  }, dispatch)
);

SignInModal.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(SignInModal);
